import HomeView from "@/pages/home/HomeView.vue";
import { DefaultLayout } from "@/widgets/app-layout";

const AdminRoutes = [
  {
    path: "/admin",
    name: "admin",
    role: "admin",
    component: DefaultLayout,
    meta: {
      sourceRoot: true,
      isMain: true,
      title: "Admin Home",
    },
    redirect: { name: "admin_home_dashboard" },
    children: [
      {
        path: "home",
        name: "admin_home_dashboard",
        component: HomeView,
        meta: {
          title: "Главная",
        },
      },
    ],
  },
];

export default AdminRoutes;
